import React from 'react';
import { FeatureContainer } from '../../../molecules/Containers/FeatureContainer';
import { ShoppingMobile as ShoppingMobileType } from '../../../../types/product/product';
import { ShoppingMobile } from '../../../molecules/ShoppingMobile';

interface ShoppingMobilesProps {
  shoppingMobiles: ShoppingMobileType[];
}

export const ShoppingMobiles = ({ shoppingMobiles }: ShoppingMobilesProps) => {
  return (
    <FeatureContainer padding="small">
      <h3>Mobiles d'achat SONCASE</h3>
      {shoppingMobiles &&
        shoppingMobiles.map((shoppingMobile, index) => (
          <ShoppingMobile key={index} shoppingMobile={shoppingMobile} />
        ))}
    </FeatureContainer>
  );
};
